export default "__VITE_ASSET__BAZuLzKy__"